import normalize from "json-api-normalize";
import Attributes from "../../models/Attributes.js";
import Vue from 'vue';

export const PaymentsApi = {

  updatePaymentPurchaseRequestData(paymentId, params) {
    return Vue.http.patch(`/api/customers/payments/${paymentId}/update_purchase_request`, params).then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.paymentAttributes);
    })
  },

  getPaymentMethods() {
    return Vue.http.get("/api/customers/payment_methods").then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.paymentMethodAttributes);
    })
  },

  getPaymentMethod(id) {
    return Vue.http.get(`/api/customers/payment_methods/${id}`).then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.paymentMethodAttributes);
    })
  },

  createPaymentMethod(params) {
    return Vue.http.post("/api/customers/payment_methods", params).then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.paymentMethodAttributes);
    })
  },

  getLicenseAgreementText(paymentId) {
    return Vue.http.get(`/api/customers/payments/${paymentId}/license_agreement`).then(fulfilled => {
      return fulfilled.body.agreement_text;
    })
  },

  getLicenseAvailable(paymentId) {
    return Vue.http.get(`/api/customers/payments/${paymentId}/license_available`).then(fulfilled => {
      return fulfilled.body;
    })
  }
}